import type React from "react";
import {useParams} from "react-router-dom";

import {faStar} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {usePlaylist, usePlaylistRealtimeSub} from "~/api/hooks/usePlaylist";
import CustomButton from "~/component/common/CustomButton";

import useModal from "../../../../hooks/useModal";
import ToggleFeaturedContent from "./ToggleFeaturedContent";

const ToggleFeaturedModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();
  const {playlistId} = useParams<{playlistId: string}>();
  const {data: playlist, isLoading} = usePlaylist({id: playlistId});
  usePlaylistRealtimeSub({id: playlistId});

  if (isLoading || !playlist) {
    return null;
  }

  return (
    <>
      <CustomButton
        onClick={openModal}
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
        title={playlist.featured ? "Manage featured status" : "Add to featured"}
      >
        <FontAwesomeIcon
          icon={faStar}
          size="xl"
          className={`text-white p-2 -m-2 rounded-full ${
            playlist.featured
              ? "bg-gradient-to-br from-yellow-500 via-yellow-400 to-amber-600"
              : "bg-gradient-to-br from-gray-600 via-gray-500 to-black"
          }`}
        />
      </CustomButton>
      <Modal>
        <ToggleFeaturedContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default ToggleFeaturedModalButton;
